import CartHandler from "./cart-handler";
import StickyTitle from "./sticky-title";

class ProductSingle {
  private scope: any;

  constructor() {
    this.scope = {
      cartHandler: new CartHandler(),
      stickyTitle: new StickyTitle(),
    };
  }

  init() {
    this.scope.cartHandler.init();
    this.scope.stickyTitle.init();


    let locationHref = new URL(window.location.href);
    if (locationHref.searchParams.has('configuratorId') && !locationHref.searchParams.has('noscroll')) {
      const top = (document.querySelector('.o-roomle-iframe')?.getBoundingClientRect().top || 0) - 80;
      window.scrollTo({top, left: 0, behavior: 'smooth'});
    }
  }
}

export default ProductSingle;
